<div [ngClass]="{'d-print-none': printService.contents}">
  <router-outlet></router-outlet>
</div>
<div class="d-none d-print-block" [innerHTML]="printService.contents"></div>
